import React from 'react';

import LegalPolicyPage from './LegalPolicyPage';

interface DPDPCompliancePageProps {
  onNavigate: (view: string) => void;
}

const DPDPCompliancePage: React.FC<DPDPCompliancePageProps> = ({ onNavigate }) => (
  <LegalPolicyPage policyId="dpdp" onNavigate={onNavigate} />
);

export default DPDPCompliancePage;
